import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { Circle } from "./Circle";
import { Rectangle } from "./Rectangle";
import { getDistance } from "../../Utils/NumberUtils";
export var QuadTree = /*#__PURE__*/function () {
  function QuadTree(rectangle, capacity) {
    var _this = this;

    _classCallCheck(this, QuadTree);

    this.rectangle = rectangle;
    this.capacity = capacity;

    this._subdivide = function () {
      var _this$rectangle$posit = _this.rectangle.position,
          x = _this$rectangle$posit.x,
          y = _this$rectangle$posit.y,
          _this$rectangle$size = _this.rectangle.size,
          width = _this$rectangle$size.width,
          height = _this$rectangle$size.height,
          capacity = _this.capacity;

      for (var i = 0; i < 4; i++) {
        _this._subs.push(new QuadTree(new Rectangle(x + width / 2 * (i % 2), y + height / 2 * (Math.round(i / 2) - i % 2), width / 2, height / 2), capacity));
      }

      _this._divided = true;
    };

    this._points = [];
    this._divided = false;
    this._subs = [];
  }

  _createClass(QuadTree, [{
    key: "insert",
    value: function insert(point) {
      if (!this.rectangle.contains(point.position)) {
        return false;
      }

      if (this._points.length < this.capacity) {
        this._points.push(point);

        return true;
      }

      if (!this._divided) {
        this._subdivide();
      }

      return this._subs.some(function (sub) {
        return sub.insert(point);
      });
    }
  }, {
    key: "query",
    value: function query(range, check, found) {
      var res = found || [];

      if (!range.intersects(this.rectangle)) {
        return [];
      }

      var _iterator = _createForOfIteratorHelper(this._points),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var p = _step.value;

          if (!range.contains(p.position) && getDistance(range.position, p.position) > p.particle.getRadius() && (!check || check(p.particle))) {
            continue;
          }

          res.push(p.particle);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (this._divided) {
        var _iterator2 = _createForOfIteratorHelper(this._subs),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var sub = _step2.value;
            sub.query(range, check, res);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      return res;
    }
  }, {
    key: "queryCircle",
    value: function queryCircle(position, radius, check) {
      return this.query(new Circle(position.x, position.y, radius), check);
    }
  }, {
    key: "queryRectangle",
    value: function queryRectangle(position, size, check) {
      return this.query(new Rectangle(position.x, position.y, size.width, size.height), check);
    }
  }]);

  return QuadTree;
}();